/*---------------------------------------------------------------------------------------------
* Copyright (c) Bentley Systems, Incorporated. All rights reserved.
* See LICENSE.md in the project root for license terms and full copyright notice.
*--------------------------------------------------------------------------------------------*/

import { ProgressLinear } from "@itwin/itwinui-react";
import { useEffect, useState } from "react";
import { ProcessStatus } from "store/features";
import { SvgIModelJs } from "../../icons/SvgIModeljs";
import styles from "./VisualizerInProgress.module.css";

export const VisualizerInProgress = ({ status }: { status: ProcessStatus }) => {
  const [message, setMessage] = useState("Building...");

  useEffect(() => {
    if (status === "building")
      setMessage("Building...")
    if (status === "loading-dependencies")
      setMessage("Loading Dependencies...")
  }, [status]);

  return (
    <div className={styles.previewLoading}>
      <div className={[styles.item, styles.icon].join(" ")}>
        <SvgIModelJs className={styles.icon} />
      </div>
      <div className={styles.item}>
        <ProgressLinear indeterminate={true} labels={[message]} />
      </div>
    </div>
  );
};

